/**
 * Clinical display formatting utilities for calculator results
 */
export const formatDoseDisplay = (value, decimals = 1) => {
  if (typeof value !== "number" || isNaN(value)) {
    return "-";
  }

  if (value % 1 === 0) {
    return Math.round(value).toString();
  }
  const multiplier = Math.pow(10, decimals);
  const truncated = Math.floor(value * multiplier) / multiplier;
  return truncated.toFixed(decimals);
};

export const formatWeightDisplay = (value, decimals = 1) => {
  return formatDoseDisplay(value, decimals);
};

export const formatClearanceDisplay = (value) => {
  return formatDoseDisplay(value, 0);
};
